import {relativePath} from "../../lib/tools";
import {Button, RelativeSwitch} from "../common/common";
import React, {Component, Fragment} from "react";
import {Link, Redirect, Route} from "react-router-dom";
import {BannerHeader} from "../structure"
import {reduxWrapper} from "../../globalState";
//Images
import profileHeaderImg from "../../resources/images/myPages.jpg";
import ProfileView from "./profile";

//Icons

const MyPages = {
	// fester: {
	// 	title: "Mine fester",
	// 	text: "Alle tidligere fester du har arbejdet på, ønsker du at dele, redigere eller slette en fest kan det gøres her.",
	// 	image: partiesHeaderImg,
	// 	content: <Parties/>
	// },
	profil: {
		title: "Min Profil",
		text: "Her kan du rette dine profil indstillinger.",
		image: profileHeaderImg,
		content: <ProfileView/>
	},
	// addresser: {
	// 	title: "Adresse",
	// 	text: "Det er muligt at tilføje flere leveringsadresser. Hvis du ønsker at noget sendes direkte til feststedet og andet til din hjemme adresse.",
	// 	image: partiesHeaderImg,
	// 	content: <AddressView/>
	// },
	// betaling: {
	// 	title: "Betalingsmetoder",
	// 	text: "Ved at gemme dit betalingskort på Festen.dk kan du hurtigt gå gennem købsprocessen. Du kan naturligvis altid fjerne dit kort.",
	// 	image: profileHeaderImg,
	// 	content: <PaymentView/>
	// },
	// kontakt: {
	// 	title: "Kontakt os",
	// 	text: "Har du spørgsmål om levering, varer, oplevelser eller lignende? Så er du meget velkommen til at stille dem her.",
	// 	image: partiesHeaderImg,
	// 	content: <ContactView/>
	// },
}

export const MyPagesWrapper = ({page, logOut}) => (
	<div className="myPagesWrapper">
		<BannerHeader bgImage={MyPages[page].image}>
			<h1>{MyPages[page].title}</h1>
			<p>{MyPages[page].text}</p>
		</BannerHeader>
		<article className="myPagesContainer maxWidth">
			<Sidebar logOut={logOut}/>
			<div className="contentWrapper">
			{MyPages[page].content}
			</div>
		</article>
	</div>
);

const UserViewsRender = ({userId, userToken, logOut}) => (
	<Fragment>
		{userId ?
			<RelativeSwitch>
				<Route path=":myPage" render={({match: {params: {myPage}}}) => <MyPagesWrapper page={myPage} logOut={logOut}/>}/>
			</RelativeSwitch> :
			(userToken && <Redirect to="/"/>)
		}
	</Fragment>
);
export const UserViews = reduxWrapper("getUserId", "loadUserToken", "getLogOut")(UserViewsRender);


export const Sidebar = ({logOut}) => (
	<div className="sidebar">
		<UserNav logOut={logOut}/>
		<Button className="light" to="/minfest">Tilbage til din fest</Button>
	</div>
);

class MenuItem extends Component{
	constructor(props) {
		super(props);

		this.state = {
			chosenLink: ""
		}

		this.setChosenLink = this.setChosenLink.bind(this); 
	}

	setChosenLink(link){
		this.setState({
			chosenLink: link
		});
	}
	
	setLinkAndHide(link, onHide){
		this.setChosenLink(link);
		onHide();
	}

	render(){
		const{name, children} = this.props;
		return(
			<Link 
				className={["navLink", relativePath("./.") === relativePath(`./${name}`) && "navLinkActive"].join(" ")} 
				to={`/mine-sider/${name}`} 
				onMouseDown={e => e.preventDefault()} 
				onClick={() => this.setChosenLink(name)}
			>
				<span>{children}</span>
			</Link>
		)
	}
};

export const UserNav = ({logOut}) => (
	<nav className ="userNavLinks">
		{/* <MenuItem name="fester">Mine fester</MenuItem> */}
		<MenuItem name="profil">Min profil</MenuItem>
		{/* <MenuItem name="addresser">Adresser</MenuItem> */}
		{/* <MenuItem name="betaling">Betalingsmetoder</MenuItem> */}
		{/* <MenuItem name="kontakt">Kontakt os</MenuItem> */}
		<div className="navLink" onClick={() => logOut()}><span>Log ud</span></div>
	</nav>
);

export const MobileNav = ({onHide, userId, logOut}) => (
	<Fragment>	
		<Link onClick={onHide} className="navLink" to="/">
			<div className="linkIcon">
				{/* <img src={BundleIcon} alt={"Overblik"}/> */}
			</div>
			<span>Overblik</span>
		</Link>
		{userId == null ? 
			<Link onClick={onHide} className="navLink loginBtnOpen" to="/log-ind">
				<div className="linkIcon">
					{/* <img src={LoginIcon} alt={"Login"}/> */}
				</div>
				<span>Login</span>
			</Link>:
			<Fragment>
				<UserNav onHide={onHide} burger={true}/>
				<Button className="navLink loginBtnClose" noFocus={true} onClick={logOut}>
					<div className="linkIcon">
						{/* <img src={LogoutIcon} alt={"Logout"}/> */}
					</div>
					<span>Logout</span>
				</Button>
			</Fragment>
		}
	</Fragment>
);

export default UserViews;


// WEBPACK FOOTER //
// ./src/components/userPages/userViews.js